import { render, staticRenderFns } from "./ChipPago.vue?vue&type=template&id=faf6c7a8&scoped=true&"
import script from "./ChipPago.vue?vue&type=script&lang=js&"
export * from "./ChipPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf6c7a8",
  null
  
)

export default component.exports